<nb-card class="modal-full" *ngIf="_model">
  <nb-card-header>
    <div class="start align-items-center inline-flex">
      <img *ngIf="_model.pictureUrl" [src]="_model.pictureUrl" alt="Building picture" class="mr-2" style="width: 30px; height: 30px;">
      <div class="">Edit building</div>
    </div>
    <div class="end ml-4">
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-tabset fullWidth>
      <nb-tab [tabTitle]="'General'">
        <div class="form-group">
          <label for="labels">Label</label>
          <multilang-editor [model]="_model.labels" editMode="true" [htmlMode]="false" [simple]="true" [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
        </div>
        <div class="form-group">
          <label for="buildingType">Building type</label>
          <nb-select [(ngModel)]="_model.buildingType" [ngModelOptions]="{standalone: true}" fullWidth filled status="primary">
            <nb-option value="habitation">Habitation</nb-option>
            <nb-option value="public_service">Public service</nb-option>
            <nb-option value="energy_production">Energy production</nb-option>
          </nb-select>
        </div>
        <div class="form-group">
          <label for="labels">Description</label>
          <multilang-editor [model]="_model.description" editMode="true" [htmlMode]="true" [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
        </div>
        <div class="form-group">
          <label class="control-label">Build complete message</label>
          <multilang-editor [model]="_model.buildCompleteMessage" editMode="true" [htmlMode]="true" [languages]="languages" [defaultLang]="game?.defaultLang"></multilang-editor>
        </div>
        <div class="form-group">
          <label for="level">Level</label>
          <input nbInput class="form-control" type="number" fullWidth filled status="primary" placeholder=""
            [(ngModel)]="_model.level" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="card-block">
          <label>Building picture</label>
          <div class="row">
            <div class="col-3 form-group" style="text-align:center;" *ngIf="!_model.id">
              Please save new building first
            </div>
            <div class="col-3" *ngIf="_model.id">
              <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                [progress]="progressMap['OBJECT']" (fileUpdated)="handleFileUpdated($event, null)"
                [imageUrl]="_model?.pictureUrl"></image-uploader>
            </div>
            <div class="col-3 justify-content-end pr-5" *ngIf="_model.pictureUrl">
              <button nbButton ghost status="danger" (click)="deletePicture(null)">
                <nb-icon icon="trash"></nb-icon>
              </button>
            </div>
          </div>

          <div class="mt-2 flex items-center gap-3" *ngIf="_model.pictureUrl">
            <button type="button" nbButton status="info" size="small" outline
              [disabled]="loadingPictureSize"
              (click)="readPictureSize()">
              {{ loadingPictureSize ? 'Reading…' : 'Get picture size' }}
            </button>
            <span class="text-sm text-cgray-600" *ngIf="_model.pictureWidth && _model.pictureHeight">
              {{ _model.pictureWidth }} × {{ _model.pictureHeight }} px
            </span>
          </div>
    
          <label>Language specific picture</label>
            <div class="row">
              <div class="col-3 form-group" style="text-align:center;" *ngIf="!_model.id">
                Please save new building first
              </div>
              <ng-template ngFor let-lang="$implicit" [ngForOf]="languages">
                <div class="col-3" *ngIf="_model.id">
                  {{ lang }}
                  <image-uploader [activeColor]="'orangered'" [baseColor]="'lightgray'" [maxFileSizeMb]="15"
                    [progress]="progressMap['OBJECT'+lang]"
                    (fileUpdated)="handleFileUpdated($event, lang)"
                    [imageUrl]="_model.picture[lang] ? _model.picture[lang].url : null">
                  </image-uploader>
                  <div class="row justify-content-end pr-5">
                    <button nbButton ghost status="danger" (click)="deletePicture(lang)"
                      *ngIf="_model.picture[lang] && _model.picture[lang].url">
                      <nb-icon icon="trash"></nb-icon>
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
        </div>
        <div class="form-group">
          <label for="externalUrl">Embedded external URL</label>
          <input class="form-control" placeholder="Enter full url here" [(ngModel)]="_model.externalUrl">
        </div>
        <div class="form-group">
          <label class="control-label">Language specific url</label>
          <multilang-editor [model]="_model?.externalUrlByLanguage" editMode="true" [htmlMode]="false" [simple]="true"
            [languages]="languages">
          </multilang-editor>
        </div>
        <div class="form-group">
          <nb-toggle status="info" [(ngModel)]="_model.isExternalUrlInNewWindow"
          [ngModelOptions]="{standalone: true}">Opens in external browser</nb-toggle>
        </div>
        <div class="form-group" *ngIf="_model.isExternalUrlInNewWindow">
          <label class="control-label">Button label</label>
          <multilang-editor [model]="_model?.externalUrlLabel" editMode="true" [htmlMode]="false" [simple]="true"
            [languages]="languages" [defaultLang]="game?.defaultLang">
          </multilang-editor>
        </div>
      </nb-tab>
      <nb-tab [tabTitle]="'Construction parameters'">
        <div>
          <label class="block text-sm/6 font-medium text-cgray-900">Needed resources to build</label>
          <div class="mt-2">
            <app-resource-selector [resources]="resources" [resourceQuantities]="_model.neededResources"></app-resource-selector>
          </div>
        </div>
        <div>
          <label class="block text-sm/6 font-medium text-cgray-900">Given resources after built</label>
          <div class="mt-2">
            <app-resource-selector [resources]="resources" [resourceQuantities]="_model.givenResources"></app-resource-selector>
          </div>
        </div>
        <!--<div>
          <label class="block text-sm/6 font-medium text-cgray-900">CO2 impact after built</label>
          <div class="mt-2">
            <input nbInput class="form-control" type="number" fullWidth filled status="primary" placeholder=""
              [(ngModel)]="_model.co2Impact" [ngModelOptions]="{standalone: true}">
          </div>
        </div>-->
        <div>
          <label class="block text-sm/6 font-medium text-cgray-900">Population impact after built</label>
          <div class="mt-2">
            <input nbInput class="form-control" type="number" fullWidth filled status="primary" placeholder=""
              [(ngModel)]="_model.populationImpact" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="mt-2">
          
          <div class="form-group">
            <!--<div for="reward">Construction will activate mission(s)</div>
            <app-dropdown [multiple]="true" [elements]="missions" [selected]="_model.successMissions" (selectElement)="_model.successMissions = $event"></app-dropdown>-->
            <div class="form-group">
              <label for="reward">Construction/activation will activate mission(s)</label>
              <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
                [(selected)]="_model.buildActivateMissions">
                <nb-option *ngFor="let mission of missions" [value]="mission.id">
                  {{ mission.name | txtTranslate }}
                </nb-option>
              </nb-select>
            </div>
          </div>
        </div>
        <div>
          <div class="form-group">
            <label for="reward">Construction/activation will provide object(s)</label>
            <nb-select fullWidth filled status="primary" multiple placeholder="Multiple Select"
              [(selected)]="_model.buildActivateObjects">
              <nb-option *ngFor="let object of objects" [value]="object.id">
                {{ object.labels | txtTranslate }}
              </nb-option>
            </nb-select>
          </div>
        </div>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <button class="cancel" nbButton status="danger" (click)="cancel()">Cancel</button>
      <button class="save" nbButton status="success" (click)="save()">Save</button>
    </div>
  </nb-card-footer>
</nb-card>
